import { startAcmeInsuranceRenewalDemoStreamLoop } from './acmeInsuranceRenewalDemoStreamLoop.js'
import { updatePendingAcmeInsuranceRenewalDemoMessage } from './patchAcmeInsuranceRenewalDemoMessage.js'

/** @param {import('./runB2bCopilotPlanDemoStream.js').B2bStreamCtx} ctx */
export function runAcmeInsuranceRenewalDemoStream(ctx) {
  updatePendingAcmeInsuranceRenewalDemoMessage(ctx.setMessagesByThreadId, ctx.tid, ctx.pendingId, {
    demoStreamActive: true,
  })
  startAcmeInsuranceRenewalDemoStreamLoop(ctx)
}
